import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/ExploreButtons.css';

const PERIODS = [
  { key: 'weekly', updateType: 'weekly_summary', explicitType: 'weekly_summary_explicit', label: 'Recent Weekly Summary', explicitLabel: 'Recent 18+ Weekly Summary', icon: '/static/icons/clock-solid.svg' },
  { key: 'monthly', updateType: 'monthly_summary', explicitType: 'monthly_summary_explicit', label: 'Recent Monthly Summary', explicitLabel: 'Recent 18+ Monthly Summary', icon: '/static/icons/calendar-solid.svg' },
  { key: 'yearly', updateType: 'yearly_summary', explicitType: 'yearly_summary_explicit', label: 'Recent Yearly Summary', explicitLabel: 'Recent 18+ Yearly Summary', icon: '/static/icons/crown-solid.svg' },
];

const PeriodQuickLinks = ({ apiBaseUrl }) => {
  const { userRoles } = useAuth();
  const canViewExplicit = userRoles?.includes('view-explicit') || userRoles?.includes('view-explicit-exclusive');
  const [links, setLinks] = useState({});

  useEffect(() => {
    const fetches = PERIODS.flatMap((period) => {
      const requests = [
        fetch(`${apiBaseUrl}/newsfeed?update_type=${period.updateType}&per_page=1`, { credentials: 'include' })
          .then((res) => res.json())
          .then((data) => ({ key: period.key, id: data.updates?.[0]?.id ?? null })),
      ];
      if (canViewExplicit) {
        requests.push(
          fetch(`${apiBaseUrl}/newsfeed?update_type=${period.explicitType}&per_page=1`, { credentials: 'include' })
            .then((res) => res.json())
            .then((data) => ({ key: `${period.key}_explicit`, id: data.updates?.[0]?.id ?? null }))
        );
      }
      return requests;
    });

    Promise.all(fetches)
      .then((results) => {
        const next = {};
        results.forEach(({ key, id }) => { next[key] = id; });
        setLinks(next);
      })
      .catch((err) => console.error('Failed to load period summary quick links:', err));
  }, [apiBaseUrl, canViewExplicit]);

  const availablePeriods = PERIODS.filter((period) => links[period.key]);
  const availableExplicitPeriods = canViewExplicit
    ? PERIODS.filter((period) => links[`${period.key}_explicit`])
    : [];
  if (availablePeriods.length === 0 && availableExplicitPeriods.length === 0) return null;

  return (
    <div className="explore-buttons period-quick-links">
      <h2>Recent Summaries</h2>
      {availablePeriods.map((period) => (
        <Link key={period.key} to={`/period-summary/${links[period.key]}`} className="explore-button">
          <img src={period.icon} className="icon" alt={period.label} />
          {period.label}
        </Link>
      ))}
      {availableExplicitPeriods.map((period) => (
        <Link key={`${period.key}_explicit`} to={`/period-summary/${links[`${period.key}_explicit`]}`} className="explore-button">
          <img src={period.icon} className="icon" alt={period.explicitLabel} />
          {period.explicitLabel}
        </Link>
      ))}
    </div>
  );
};

export default PeriodQuickLinks;
